import React from "react";
import ServiceCtaButton from "./ServiceCtaButton";

const ServicePricing = ({ heading, description, plans = [], disclaimer }) => {
  if (!plans.length) {
    return null;
  }

  return (
    <div>
      {(heading || description) && (
        <div className="mb-10 sm:mb-12 max-w-3xl">
          {heading && (
            <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900 mb-3">
              {heading}
            </h2>
          )}
          {description && (
            <p className="text-gray-700 text-base sm:text-lg leading-relaxed">
              {description}
            </p>
          )}
        </div>
      )}

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8 items-stretch">
        {plans.map((plan, index) => (
          <div
            key={plan.name || index}
            className={`flex flex-col rounded-lg border p-6 sm:p-8 bg-white ${
              plan.highlighted
                ? "border-2 shadow-lg"
                : "border-gray-200 shadow-sm"
            }`}
            style={plan.highlighted ? { borderColor: "#db0058" } : undefined}
          >
            {/* Highlighted plans are marked with a visible text badge, not colour alone. */}
            {plan.highlighted && (
              <span
                className="self-start mb-4 inline-block text-xs font-semibold uppercase tracking-wide text-white px-3 py-1 rounded-full"
                style={{ backgroundColor: "#db0058" }}
              >
                Recommended
              </span>
            )}

            <h3 className="text-xl sm:text-2xl font-bold text-gray-900 mb-2">
              {plan.name}
            </h3>

            <div className="mb-4">
              {plan.price ? (
                <p className="text-3xl sm:text-4xl font-bold text-gray-900 break-words">
                  {plan.price}
                  {plan.billingPeriod && (
                    <span className="text-base font-medium text-gray-600">
                      {" "}
                      {plan.billingPeriod}
                    </span>
                  )}
                </p>
              ) : (
                <p className="text-xl sm:text-2xl font-bold text-gray-900">
                  {plan.contactLabel || "Contact us for pricing"}
                </p>
              )}
            </div>

            {Array.isArray(plan.features) && plan.features.length > 0 && (
              <ul className="space-y-2 mb-6 flex-1">
                {plan.features.map((feature, featureIndex) => (
                  <li
                    key={featureIndex}
                    className="flex items-start gap-2 text-sm sm:text-base text-gray-700"
                  >
                    <svg
                      className="w-5 h-5 flex-shrink-0 mt-0.5"
                      style={{ color: "#db0058" }}
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                      aria-hidden="true"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M5 13l4 4L19 7"
                      />
                    </svg>
                    <span>{feature}</span>
                  </li>
                ))}
              </ul>
            )}

            {plan.cta && (
              <div className="mt-auto">
                <ServiceCtaButton
                  cta={plan.cta}
                  variant={plan.highlighted ? "primary" : "outline"}
                  size="medium"
                  className="w-full justify-center"
                />
              </div>
            )}
          </div>
        ))}
      </div>

      {disclaimer && <p className="mt-6 text-sm text-gray-500">{disclaimer}</p>}
    </div>
  );
};

export default ServicePricing;
